import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import Dropzone from 'react-dropzone';
import ImageCropperWrapper from '../../Common/ImageCropperWrapper/ImageCropperWrapper';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import camera from '../../../images/icons/camera.svg';
import deleteIcon from '../../../images/icons/delete.svg';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import './Graphics.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

const DragHandle = SortableHandle(() => <div className="sort-handle">::</div>); // This can be any component you want

const SortableItem = SortableElement(({ index, value, handleSortableInputs, deleteRow }) => {
    return (
        <tr>
            <td className="text-center">
                {value.delete && (
                    <DragHandle />
                )}  
            </td>
            <td>
                <div className="showtix-form__group">
                    <div className="showtix-form__input">
                        <input
                            className="showtix-input"
                            type="text"
                            object="artists"
                            name="first_name"
                            id={value.id}
                            value={value.first_name}
                            onChange={handleSortableInputs}
                        />
                    </div>
                </div>
            </td>
            <td>
                <div className="showtix-form__group">
                    <div className="showtix-form__input">
                        <input
                            className="showtix-input"
                            type="text"
                            object="artists"
                            name="last_name"
                            id={value.id}
                            value={value.last_name}
                            onChange={handleSortableInputs}
                        />
                    </div>
                </div>
            </td>
            <td>
                <div className="showtix-form__group">
                    <div className="showtix-form__input">
                        <input
                            className="showtix-input"
                            type="text"
                            object="artists"
                            name="position"
                            id={value.id}
                            value={value.position}
                            onChange={handleSortableInputs}
                        />
                    </div>
                </div>
            </td>
            <td className="text-right">
                {value.delete && 
                    <button
                        className="showtix-button showtix-button__simple"
                        object="artists"
                        id={value.id}
                        onClick={deleteRow}
                    >
                        <img
                            className="delete-icon"
                            src={deleteIcon}
                            alt={value.id}
                        />
                    </button>
                }
            </td>
        </tr>
    );
});

const SortableList = SortableContainer(({ items, handleSortableInputs, deleteRow }) => {
    return (
        <tbody>
            {items.map((value, index) => (
                <SortableItem
                    key={`item-${index}`}
                    index={index}
                    value={value}
                    handleSortableInputs={handleSortableInputs}
                    deleteRow={deleteRow}
                />
            ))}
        </tbody>
    );
});

class Graphics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            posters: [],
            advertisement: [],
            showPosterLightbox: false,
            showPosterPreview: false,
            posterPreview: "",
            posterBlob: "",
            croppedPoster: null,
            showAdLightbox: false,
            showAdPreview: false,
            adPreview: "",
            adBlob: "",
            croppedAd: null
        }
        this.posterFilesUpdate;
        this.adFilesUpdate;
    }

    /* poster */

    renderPosterCropper = () => {
        let preview = (this.state.posterBlob) ? this.state.posterBlob.preview : "";
        let posterCropper = 
        <Modal className="modal-lg" isOpen={this.state.showPosterLightbox} toggle={this.togglePosterLightbox}>
            <ModalHeader toggle={this.togglePosterLightbox}>{strings.cropTitle}</ModalHeader>
            <ModalBody>
                <ImageCropperWrapper 
                    imgSrc={preview}
                    updateImagePreview={this.updatePosterPreview}
                />
            </ModalBody>
            <ModalFooter>
                <button 
                    type="submit" 
                    className="showtix-button showtix-background__primary-3"
                    onClick={this.onPosterButtonClick}>
                    {strings.cropButton}
                </button>
            </ModalFooter>
        </Modal>;
        return posterCropper;
    }

    onPosterButtonClick = () => {
        this.setState({
            posters: this.posterFilesUpdate,
            showPosterLightbox: false,
            showPosterPreview: true
        });
        console.log(this.state.croppedPoster);
        this.props.uploadFile(this.state.posterBlob, 'details', 'poster_graphic_id', this.state.croppedPoster);
    }

    togglePosterLightbox = () => {
        this.setState({
            showPosterLightbox: !this.state.showPosterLightbox
        });
    }

    updatePosterPreview = (imageUrl, croppedImage) => {
        this.setState({
            posterPreview: imageUrl,
            croppedPoster: croppedImage
        });
    }

    dropPoster = (filesUpdate) => {
        let posterBlob = (filesUpdate[0] instanceof Blob) ? filesUpdate[0] : "";

        this.setState({
            posterBlob,
            showPosterLightbox: true,
            showPosterPreview: false
        });
    }


    /* ad */
    renderAdCropper = () => {
        let preview = (this.state.adBlob) ? this.state.adBlob.preview : "";
        let adCropper = 
        <Modal className="modal-lg" isOpen={this.state.showAdLightbox} toggle={this.toggleAdLightbox}>
            <ModalHeader toggle={this.toggleAdLightbox}>{strings.cropTitle}</ModalHeader>
            <ModalBody>
                <ImageCropperWrapper 
                    imgSrc={preview}
                    updateImagePreview={this.updateAdPreview}
                    ratio={7.5 / 1.5}
                    width={400}
                />
            </ModalBody>
            <ModalFooter>
                <button 
                    type="submit" 
                    className="showtix-button showtix-background__primary-3"
                    onClick={this.onAdButtonClick}>
                    {strings.cropButton}
                </button>
            </ModalFooter>
        </Modal>;
        return adCropper;
    }

    onAdButtonClick = () => {
        this.setState({
            posters: this.adFilesUpdate,
            showAdLightbox: false,
            showAdPreview: true
        });
        this.props.uploadFile(this.state.adBlob, 'details', 'ad_graphic_id', this.state.croppedAd);
    }

    toggleAdLightbox = () => {
        this.setState({
            showAdLightbox: !this.state.showAdLightbox
        });
    }

    updateAdPreview = (imageUrl, croppedImage) => {
        this.setState({
            adPreview: imageUrl,
            croppedAd: croppedImage
        });
    }

    dropAdvertisement = (filesUpdate) => {
        let adBlob = (filesUpdate[0] instanceof Blob) ? filesUpdate[0] : "";

        this.setState({
            adBlob,
            showAdLightbox: true,
            showAdPreview: false
        });
    }

    clearFile = (e) => {
        e.stopPropagation();

        this.setState({
            [e.target.getAttribute('showtoclear')]: false,
            [e.target.getAttribute('postertoclear')]: "",
            [e.target.getAttribute('previewtoclear')]: ""
        });
        this.props.clearFile(e);
    }

    clearFiles = () => {
        this.setState({
            posterPreview: '',
            adPreview: '',
            showPosterPreview: false,
            showAdPreview: false
        });
    }

    componentWillReceiveProps(props) {
        if(props.isClearUpload){
            this.clearFiles();
        }
    }

    render() { 
        return ( 
            <div className="showtix-section container">
                <div className="row">
                    <div className="col-12 col-lg-9">
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label">{strings.poster}
                                        <span id="tooltip-poster" className="showtix-tooltip">!</span>
                                        <Tooltip placement="top" target="tooltip-poster">
                                            {strings.posterTooltip}
                                        </Tooltip>
                                    </label>

                                    <div className="showtix-form__drop">
                                        <Dropzone
                                            className="showtix-dropzone"
                                            onDrop={this.dropPoster}
                                            accept="image/jpeg, image/png, image/gif"
                                            maxSize={3000000}
                                            multiple={false}>
                                            <div className="showtix-dropzone__title">{strings.dragAndDropImages}</div>
                                            <img src={camera} alt="Upload file for Poster" />
                                            <div className="showtix-dropzone__file">
                                                {this.state.showPosterPreview &&
                                                    <div className="showtix-dropzone__file__content">
                                                        <img 
                                                            className="delete-icon" 
                                                            src={deleteIcon} 
                                                            alt="delete icon" 
                                                            objectname="poster"
                                                            postertoclear="posterBlob"
                                                            previewtoclear="posterPreview"
                                                            showtoclear="showPosterPreview"
                                                            onClick={this.clearFile}  
                                                        />
                                                        {/* <div><span>{this.state.posterBlob.name} - {this.state.posterBlob.size} bytes</span></div> */}
                                                        <img src={this.state.posterPreview} className="showtix-dropzone__preview" alt="poster preview" />
                                                    </div>
                                                }
                                            </div>
                                        </Dropzone>
                                        { this.renderPosterCropper() }
                                    </div>
                                    { this.props.event.details.poster_graphic_url &&
                                        <div className="showtix-event-image">
                                            <img id="jsPosterImage" src={this.props.event.details.poster_graphic_url || ''} />
                                            <br />
                                            <button 
                                                onClick={this.props.clearImage}
                                                objectid="poster_graphic_id"
                                                objecturl="poster_graphic_url"
                                                className="showtix-button showtix-button__xsmall showtix-background__primary-2"
                                            >{strings.deleteImage}</button>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label">{strings.advertisement}
                                        <span id="tooltip-advertisement" className="showtix-tooltip">!</span>
                                        <Tooltip placement="top" target="tooltip-advertisement">
                                            {strings.advertisementTooltip}
                                        </Tooltip>
                                    </label>

                                    <div className="showtix-form__drop">
                                        <Dropzone
                                            className="showtix-dropzone"
                                            onDrop={this.dropAdvertisement}
                                            accept="image/jpeg, image/png, image/gif"
                                            maxSize={3000000}
                                            multiple={false}>
                                            <div className="showtix-dropzone__title">{strings.dragAndDropImages}</div>
                                            <img src={camera} alt="Upload file for Advertisement" />
                                            <div className="showtix-dropzone__file">
                                                {this.state.showAdPreview &&
                                                    <div className="showtix-dropzone__file__content">
                                                        <img 
                                                            className="delete-icon" 
                                                            src={deleteIcon} 
                                                            alt="delete icon" 
                                                            objectname="dropAdvertisement" 
                                                            postertoclear="adBlob"
                                                            previewtoclear="adPreview"
                                                            showtoclear="showAdPreview"
                                                            onClick={this.clearFile}  
                                                        />
                                                        {/* <div><span>{this.state.adBlob.name} - {this.state.adBlob.size} bytes</span></div> */}
                                                        <img src={this.state.adPreview} className="showtix-dropzone__preview" alt="ad preview" />
                                                    </div>
                                                }
                                            </div>
                                        </Dropzone>
                                        { this.renderAdCropper() }
                                    </div>
                                    { this.props.event.details.ad_graphic_url &&
                                        <div className="showtix-event-image">
                                            <img src={this.props.event.details.ad_graphic_url || ''} />
                                            <br />
                                            <button 
                                                onClick={this.props.clearImage}
                                                objectid="ad_graphic_id"
                                                objecturl="ad_graphic_url"
                                                className="showtix-button showtix-button__xsmall showtix-background__primary-2"
                                            >{strings.deleteImage}</button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <label className="showtix-label">{strings.artists}
                                    <span id="tooltip-artists" className="showtix-tooltip">!</span>
                                    <Tooltip placement="top" target="tooltip-artists">
                                        {strings.artistsTooltip}
                                    </Tooltip>
                                </label>

                                <div className="showtix-form__group">
                                    <div className="table-responsive">
                                        <table className="showtix-table" id="artists" width="100%">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>{strings.firstName}</th>
                                                    <th>{strings.lastName}</th>
                                                    <th>{strings.role}</th>
                                                    <th style={{ width: 50 }}></th>
                                                </tr>
                                            </thead>
                                            <SortableList
                                                items={this.props.event.artists}
                                                onSortStart={this.props.onSortStart}
                                                onSortEnd={this.props.onSortEnd}
                                                handleSortableInputs={this.props.handleSortableInputs}
                                                deleteRow={this.props.deleteRow}
                                                lockToContainerEdges={true}
                                                lockAxis='y'
                                                useDragHandle={true} />
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.props.event.details.img &&
                    <div className="col-12 col-md-3">
                        <div className="showtix-box poster-box">
                            <div className="showtix-padder">
                                <h3 className="showtix-box__title">{strings.didYouKnow}</h3>
                                <img className="showtix-box__poster" src={this.props.event.details.img} alt="poster"/>
                                <p>{strings.didYouKnowDetails}</p>
                                <p>{strings.didYouKnowVisit}
                                    <Link to="/">{strings.didYouKnowLink}</Link> {strings.didYouKnowMoreInfo}
                                </p>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        )
    }
}

Graphics.propTypes = {
    event: PropTypes.shape({
        artists: PropTypes.array,
        details: PropTypes.shape({
            img: PropTypes.string
        })
    }),
    uploadFile: PropTypes.func,
    onSortEnd: PropTypes.func,
    onSortStart: PropTypes.func,
    handleSortableInputs: PropTypes.func,
    deleteRow: PropTypes.func
}
 
export default Graphics;


// WEBPACK FOOTER //
// ./src/components/CreateEvent/Graphics/Graphics.js